module.exports = __webpack_public_path__ + "static/media/4.e0c8d3cf.mp4";